import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ImpactResultSkeleton',
  props: {
    tall: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var bodySkeletonType = computed(function () {
      return props.tall ? 'image, article, list-item@2' : 'article, list-item@2';
    });
    return {
      __sfc: true,
      props: props,
      bodySkeletonType: bodySkeletonType
    };
  }
});